import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { map, catchError } from 'rxjs/operators';
import { _throw } from 'rxjs/observable/throw';
import { NotificationService } from '../../../../../feature-modules/admin/service/notification.service';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EncriptDecriptService } from '../../../../../services/encriptdecript';

@Injectable()
export class QuizReviewService {

    
    
    constructor(private http: HttpClient, private router: Router,
        public activeModal: NgbActiveModal,
        private encriptDecriptService:EncriptDecriptService,
        private notificationService: NotificationService) { }
        
        private standardHeaders() {
            return {
                'Content-Type': 'application/json',
                'token': this.encriptDecriptService.getKeyLocalStorage('token')
            };
        }
        
    goToLoginPage() {
        this.activeModal.close();   
        this.router.navigate(['/login']);
        sessionStorage.clear();
        localStorage.clear();
        this.notificationService.sessionExpaireNotification();
      }

    public getQuizReview(user, quizAttempt, launchUrl): Observable<any> {
        const url = ` ${environment.api_url1}/category/quizReport`;
        return this.http.post(url, {user, quizAttempt, launchUrl}, {
            headers: this.standardHeaders()
        })
        .pipe(
            map((response: any) => {
              return response;
            }),
            catchError(error => {
              if (error.status == 401) { this.goToLoginPage(); }
              return _throw(error);
            })
            );
    }
}




// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user-dashboard/user-dashboardcards/charts/quiz-review/quiz-review.service.ts